export default{
    "clinics.detail.cart.missingRequiredFields.title"    : "Missing information",
    "clinics.detail.cart.missingRequiredFields.text"     : "We need this information in order to let you register your member.",
    "clinics.detail.cart.missingRequiredFields.text2"    : "Please fill out the fields below.",
    "clinics.detail.cart.missingRequiredFields.required" : "This field is required",
}